// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--E8IIV","info":"e2ff468f85--info--qxDIV","short_name":"e2ff468f85--short_name--_h0zT","full_name":"e2ff468f85--full_name--erDJZ"};